/* Pop-out cart tightening — the text parts (decided by Suhail 15 Oct 2026). Pairs with bl-cart-tight.css.
   Only rewrites words the cart already shows; never touches the Breeze button's click or classes. */
(function () {
  if (window.__blct) return;
  window.__blct = true;

  function root() { var r = document.getElementById("blCartDrawerRoot"); return r && !r.classList.contains("bl-cartpage") ? r : null; }
  function num(t) { var m = String(t || "").replace(/,/g, "").match(/\d+(\.\d+)?/); return m ? Number(m[0]) : 0; }
  function inr(n) { return "₹" + Math.round(n).toLocaleString("en-IN"); }

  // 1 · the headline (his rules 15 Oct):
  //   far from the next step → "Extra ₹600 off on SALE items above ₹2,799"
  //   within ₹500            → "₹2 more on SALE = ₹600 off"
  //   a step reached         → "₹600 off unlocked · ₹1,202 more = ₹1,200 off"
  // The gap is the cart's OWN SALE-only figure, read from its hidden nudge ("Spend ₹X more on SALE products
  // to unlock Get Extra ₹Y …") — never the bag total. Steps come from the rail's own reward labels.
  var CLOSE = 500;
  function headline(r) {
    var h = r.querySelector(".blcb-offer-head");
    if (!h) return;
    var nudge = r.querySelector(".bl-cartdrawer__nudge"), nt = nudge ? nudge.textContent : "";
    var gapM = nt.match(/Spend\s+₹\s*([\d,]+)\s+more/i), nextM = nt.match(/Extra\s+₹\s*([\d,]+)/i);
    var steps = [];
    r.querySelectorAll(".bl-cartdrawer__offer-marker").forEach(function (m) {
      var rw = m.querySelector(".blcb-tier-reward"), v = m.querySelector(".bl-cartdrawer__offer-marker-value");
      var reward = rw ? num(rw.textContent) : 0, at = v ? num(v.textContent) : 0;
      if (reward) steps.push({ reward: reward, at: at, next: m.classList.contains("is-next") });
    });
    var next = steps.filter(function (s) { return s.next; })[0];
    var reached = next ? steps.filter(function (s) { return s.at < next.at; }) : steps;
    var got = reached.length ? reached[reached.length - 1] : null;
    if (!next) { // no "next" marker: either every step is reached (bar full) or there are no SALE items at all
      var p = r.querySelector(".bl-cartdrawer__offer-progress");
      if (!p || !(parseFloat(p.style.width) >= 99)) got = null;
    }
    var gap = gapM ? num(gapM[1]) : 0, nextReward = nextM ? num(nextM[1]) : (next ? next.reward : 0);
    var text = null;
    if (got && gap > 0 && nextReward) text = inr(got.reward) + " off unlocked · " + inr(gap) + " more = " + inr(nextReward) + " off";
    else if (got && !next) text = inr(got.reward) + " off unlocked on SALE items";
    else if (gap > 0 && gap <= CLOSE && nextReward) text = inr(gap) + " more on SALE = " + inr(nextReward) + " off";
    var t = h.textContent;
    if (!text) text = t.replace(/^\s*Get\s+Extra\s+/i, "Extra ").replace(/\/-\s*/g, " ").replace(/SALE products/g, "SALE items");
    if (text !== t) h.textContent = text;
  }

  // 2 · the tag on each rail step shows its saving
  function pills(r) {
    r.querySelectorAll(".bl-cartdrawer__offer-marker").forEach(function (m) {
      var rw = m.querySelector(".blcb-tier-reward"), dot = m.querySelector(".bl-cartdrawer__offer-marker-dot");
      if (!rw || !dot) return;
      var n = (rw.textContent.match(/[\d,]+/) || [""])[0];
      if (!n) return;
      var label = "₹" + n + " off", p = dot.querySelector(".blct-pill");
      if (!p) { p = document.createElement("span"); p.className = "blct-pill"; dot.appendChild(p); dot.classList.add("blct-has-pill"); }
      if (p.textContent !== label) p.textContent = label;
    });
  }

  // 4 · the green strip sticks right under the offer block, whatever its height
  function stick(r) {
    var o = r.querySelector(".bl-cartdrawer__offers");
    if (!o) return;
    var h = Math.round(o.getBoundingClientRect().height);
    if (h > 0 && r.style.getPropertyValue("--blct-off") !== h + "px") r.style.setProperty("--blct-off", h + "px");
  }

  // 6 · " to CHENNAI, TAMIL NADU — 600017" → " · Chennai 600017"
  function pin(r) {
    var s = r.querySelector(".bpdp-pincode-result strong");
    if (!s) return;
    var holder = s.parentElement;
    holder.classList.add("blct-pin-line");
    holder.childNodes.forEach(function (n) {
      if (n.nodeType !== 3) return;
      var m = n.textContent.match(/to\s+([^,—]+)(?:,[^—]*)?—\s*(\d{6})/);
      if (!m) return;
      var city = m[1].trim().toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      n.textContent = " · " + city + " " + m[2];
    });
  }

  // 7–8 · the saving and the total sit on the Breeze button itself: "Checkout   [Save ₹750] ₹1,748 →"
  // (his call 15 Oct: no separate band). "Checkout" stays visible: bl-path.js counts the click by that word.
  function bottom(r) {
    var price = r.querySelector(".bl-cartdrawer__summary-price"), cmp = r.querySelector(".bl-cartdrawer__summary-compare");
    var text = r.querySelector(".bl-cartdrawer__checkout-text");
    if (!price || !text) return;
    // saving = every line's MRP (its struck-out price, or its price when it has none) minus the total —
    // the summary's own "compare" figure switches to the pre-offer subtotal once a step is unlocked (found 15 Oct)
    var total = num(price.textContent), mrp = 0;
    r.querySelectorAll(".bl-cartdrawer__items .bl-cartdrawer__price-block").forEach(function (b) {
      var c = b.querySelector(".bl-cartdrawer__compare"), p = b.querySelector(".bl-cartdrawer__price");
      mrp += num((c && c.textContent.trim()) ? c.textContent : (p ? p.textContent : ""));
    });
    if (!mrp && cmp && !cmp.hidden) mrp = num(cmp.textContent);
    var save = mrp > total ? mrp - total : 0;
    var amt = text.querySelector(".blct-amt");
    if (!amt) { amt = document.createElement("span"); amt.className = "blct-amt"; text.appendChild(amt); }
    var amtHtml = total > 0 ? (save > 0 ? "<em>Save " + inr(save) + "</em>" : "") + inr(total) + " →" : "";
    if (amt.innerHTML !== amtHtml) amt.innerHTML = amtHtml;
  }

  // 6b · the pincode line stays fixed at the bottom with "Have a gift voucher?" (his ask 15 Oct):
  // the same element is moved into the footer, so its own listeners keep working.
  function freezePin(r) {
    var pin = r.querySelector(".bl-cartdrawer__body .bpdp-pincode"), foot = r.querySelector(".bl-cartdrawer__footer");
    if (!pin || !foot) return;
    var blv = foot.querySelector(".blv");
    foot.insertBefore(pin, blv || foot.firstChild);
  }

  // 10 · item prices without paise (his ask 15 Oct): once an offer is unlocked the cart spreads it across the
  // lines and shows "₹2,268.16"; we show "₹2,268". Display only — the checkout amount is unchanged.
  function paise(r) {
    r.querySelectorAll(".bl-cartdrawer__items .bl-cartdrawer__price, .bl-cartdrawer__items .bl-cartdrawer__compare").forEach(function (e) {
      if (e.children.length) return;
      var t = e.textContent, n = t.replace(/₹\s*([\d,]+\.\d+)/g, function (_, a) { return inr(Number(a.replace(/,/g, ""))); });
      if (n !== t) e.textContent = n;
    });
  }

  var busy = false;
  function run() {
    var r = root();
    if (!r || busy) return;
    busy = true;
    try { headline(r); pills(r); freezePin(r); pin(r); bottom(r); paise(r); stick(r); } catch (_) {}
    busy = false;
  }

  function boot() {
    var r = root();
    if (!r) return;
    run();
    var t = null;
    new MutationObserver(function () { if (busy) return; clearTimeout(t); t = setTimeout(run, 60); })
      .observe(r, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["hidden", "class"] });
    window.addEventListener("resize", function () { stick(r); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
